<template>
  <div class="h5" style="padding-top: 50px;">
    <div class="help">
      <div class="help_content_left">
        <div class="help_content_serch">
          <input type="text" placeholder="搜索" class="serch" v-model="serch_content" @input="serch" />
          <img src="../../static/image/serch.png" alt class="sousuo" />
          <img src="../../static/image/del.png" alt class="del" v-if="del_remove" @click="remove" />
        </div>
        <div class="fuzzy_serch">
          <ul>
            <li v-for="(item,i) in serch_list" :class="[item.id==suoyin?'active':'']" :key="i" @click="isActivation(item.id)">{{item.article_title}}</li>
          </ul>
          <ul v-if="!serch_list.length && wuData">
            <li style="text-align:center">暂无数据</li>
          </ul>
        </div>
        <div class="help_content_title">
          <h2>帮助中心</h2>
        </div>
        <div class="directory" v-for="(item,i) in help_center" :key="i">
          <h3>{{item.brand_name}}</h3>
          <ul>
            <li
              v-for="(itemC,index) in item.article_list"
              :class="[itemC.id==suoyin?'active':'']"
              @click="isActivation(itemC.id)"
              :key="index"
            >{{itemC.article_title}}</li>
          </ul>
        </div>
      </div>
      <div class="help_content_right">
        <div class="help_content_right_title">
          <h2>{{content.article_title}}</h2>
        </div>
        <div class="help_content_right_content" v-html="content.article_content"></div>
        <div class="foot">
          <div class="foot_left" v-if="last" @click="last_chapter(article_id)">
            <div class="foot_left_last">&lt; 上一章</div>
            <div class="foot_left_title">{{last_content}}</div>
          </div>
          <div class="foot_right" v-if="next" @click="next_chapter(article_id)">
            <div class="foot_right_next">下一章&gt;</div>
            <div class="foot_right_title">{{next_content}}</div>
          </div>
        </div>
      </div>
      <xfck></xfck>
    </div>
  </div>
</template>

<script>
require("../assets/css/main.css");
import Swiper from "swiper";
import $ from "jquery";
import "swiper/dist/css/swiper.min.css";
import Promise from "Promise";
import xfck from "./xfck.vue";
import { setInterval, clearInterval } from "timers";
export default {
  name: "hello",
  data() {
    return {
      help_center: [],
      suoyin: "",
      content: "",
      last: false,
      next: false,
      last_content: "",
      next_content: "",
      article_id: "",
      serch_content: "", //搜索内容
      del_remove: false,
      serch_list:[],
      wuData:false
    };
  },
  mounted() {},
  created() {
    this.get_help_center();
  },
  methods: {
    last_chapter(article) {
      this.get_article(article.last.id);
      this.suoyin = article.last.id;
    },
    next_chapter(article) {
      this.get_article(article.next.id);
      this.suoyin = article.next.id;
    },
    isActivation(id) {
      this.suoyin = id;
      this.get_article(id);
    },
    get_help_center() {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=help_center/getHelpList";
      that.axios
        .get(url, {
          params: {}
        })
        .then(res => {
          // console.log(res);
          if (res.data.success) {
            that.help_center = res.data.data.list;
            that.get_article(res.data.data.list[0].article_list[0].id);
            that.suoyin = res.data.data.list[0].article_list[0].id;
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    serch() {
      if (this.serch_content != "") {
        this.del_remove = true;
        this.get_fuzzy_serch(this.serch_content)
      } else {
        this.serch_list=[]
        this.del_remove = false;
        this.wuData = false
      }
    },
    remove() {
      this.del_remove = false;
      this.serch_content = "";
      this.wuData = false;
      this.serch_list=[]
    },
    get_fuzzy_serch(article_name) {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=help_center/searchHelpArticle";
      that.axios
        .get(url, {
          params: {
            article_name
          }
        })
        .then(res => {
          // console.log(res);
          if (res.data.success) {
              console.log(res.data.data)
              that.serch_list = res.data.data
              that.wuData = false
          } else {
               if(this.serch_content != ""){
                   that.wuData = true
               }
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    get_article(id) {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=help_center/getHelpArticleInfo";
      that.axios
        .get(url, {
          params: {
            id
          }
        })
        .then(res => {
          // console.log(res);
          if (res.data.success) {
            that.content = res.data.data.content;
            that.article_id = res.data.data;
            if (res.data.data.last.id) {
              that.last = true;
              that.last_content = res.data.data.last.article_title;
            } else {
              that.last = false;
            }
            if (res.data.data.next.id) {
              that.next = true;
              that.next_content = res.data.data.next.article_title;
            } else {
              that.next = false;
            }
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.help {
  width: 1200px;
  margin: 0 auto;
  min-height: 800px;
  /* background: chartreuse; */
  display: flex;
}
.help_content_left {
  height: 100%;
  /* background: chocolate; */
  width: 300px;
  margin-top: 50px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  min-height: 800px;
  padding: 0 5px;
}
.help_content_right {
  width: 900px;
  border-radius: 10px;
  min-height: 800px;
  margin-top: 50px;
}
.help_content_right_content{
  margin: 20px 0 ;
}
.serch {
  width: 100%;
  border: none;
  border-bottom: 1px solid rgba(204, 204, 204, 1);
  padding: 5px 25px;
  outline: none;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.help_content_serch {
  position: relative;
  background: pink;
}
.help_content_serch .sousuo {
  width: 20px;
  height: 22px;
  position: absolute;
  left: 0px;
  top: 8px;
}
.del {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0px;
  top: 8px;
  cursor: pointer;
}
.help_content_title h2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin: 20px 0;
}
.directory {
  width: 100%;
}
.directory h3 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}
.directory ul {
  list-style: none;
  box-sizing: border-box;
  margin-top: 20px;
  padding-left: 10px;
}
.directory ul li {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
  padding: 10px 20px;
}
ul li.active {
  background: rgba(204, 204, 204, 1);
  color: rgba(249, 113, 0, 1);
}
.help_content_right {
  padding: 0 20px;
  position: relative;
}
.help_content_right_title {
  border-bottom: 1px solid rgba(237, 238, 243, 1);
  padding: 3px 0;
}
.help_content_right_title h2 {
  text-align: center;
  font-size: 20px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
}
.foot {
  position: relative;
  width: 100%;
  border-top: 1px solid rgba(237, 238, 243, 1);
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 0;
}
.foot .foot_left {
  float: left;
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.foot .foot_right {
  float: right;
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  text-align: right;
}
.foot .foot_left_title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(80, 80, 80, 1);
  margin-top: 21px;
}
.foot .foot_right_title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(80, 80, 80, 1);
  margin-top: 21px;
}
.fuzzy_serch ul {
  list-style: none;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.fuzzy_serch ul li {
  padding: 10px 20px;
  cursor: pointer;
  word-wrap: break-word;
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/help_content.vue